<template>
    <div id="login">
        <p
            v-if="!showAlias"
            v-t="'login.form_title'"
            class="has-text-centered is-size-2 has-text-weight-bold"
        ></p>

        <form v-if="showLoginForm" action @submit.prevent>
            <div class="field is-expanded">
                <div class="field">
                    <div class="control is-expanded">
                        <input
                            v-model="input.username"
                            :placeholder="$t('login.enter_username_email')"
                            autocomplete="username email"
                            type="text"
                            name="username"
                            class="input"
                            @input="errorLogin = false"
                        />
                    </div>
                </div>
            </div>
            <div class="field is-expanded">
                <div class="field">
                    <div class="control is-expanded">
                        <input
                            v-model="input.password"
                            :placeholder="$t('login.enter_password')"
                            type="password"
                            name="password"
                            autocomplete="current-password"
                            class="input"
                            @input="errorLogin = false"
                        />
                    </div>
                </div>
            </div>
            <div class="errors">
                <span
                    v-if="errorLogin"
                    v-t="'login.error'"
                    class="has-text-danger"
                />
            </div>
            <div class="control">
                <button
                    v-t="'login.start'"
                    :disabled="emptyFields"
                    :class="{ 'is-loading': loading }"
                    class="button is-outlined is-link is-fullwidth"
                    @click="login"
                ></button>
            </div>
        </form>
        <section class="section pt-0">
            <div class="columns is-centered is-mobile">
                <div v-if="!showLoginForm" class="column is-6-desktop">
                    <a
                        v-if="!showAlias"
                        class="
                            button
                            is-medium is-primary is-outlined is-fullwidth
                        "
                        @click="loginWithGoogle"
                    >
                        <span class="icon">
                            <i class="fab fa-google"></i>
                        </span>
                        <span>Google</span>
                    </a>
                    <a
                        v-if="!showAlias"
                        class="
                            button
                            is-medium is-primary is-outlined is-fullwidth
                            mt-3
                        "
                        @click="loginWithMicrosoft"
                    >
                        <span class="icon">
                            <i class="fab fa-microsoft"></i>
                        </span>
                        <span>Microsoft</span>
                    </a>
                    <a
                        v-if="isVicensCommunity"
                        class="
                            button
                            is-medium is-primary is-outlined is-fullwidth
                            mt-3
                        "
                        @click="loginWithVVives"
                    >
                        <figure class="image is-24x24">
                            <img src="/img/icons/vicenc-white-128.png" />
                        </figure>
                        <span>&nbsp;&nbsp;Edubook</span>
                    </a>
                    <!--<div v-if="!isVicensCommunity">
                        <p
                            v-if="!showAlias"
                            class="is-size-6 pt-5 has-text-centered"
                        >
                            {{ $t('login_anonymous_hint') }}
                        </p>
                        <p v-else class="is-size-6 pt-5 has-text-centered">
                            {{ $t('login_anonymous_alias') }}
                        </p>
                        <div v-if="showAlias" class="field is-expanded">
                            <div class="field">
                                <div class="control is-expanded">
                                    <input
                                        v-model="alias"
                                        autocomplete="alias"
                                        type="text"
                                        name="alias"
                                        class="input"
                                        @input="errorLogin = false"
                                    />
                                </div>
                            </div>
                        </div>
                        <a
                            class="
                                button
                                is-medium is-primary is-light
                                has-text-primary
                                is-fullwidth
                                mt-3
                            "
                            @click="loginAnonymous"
                        >
                            <span v-if="!showAlias">{{
                                $t('login_anonymous')
                            }}</span>
                            <span v-else>{{ $t('login.form_title') }}</span>
                        </a>
                    </div>-->
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import AuthService from '@/services/auth.service';
export default {
    name: 'Loginlocal',
    data() {
        return {
            input: {
                username: '',
                password: '',
            },
            errorLogin: false,
            loading: false,
            showLoginForm: false,
            alias: '',
            showAlias: false,
        };
    },
    computed: {
        emptyFields: function () {
            return this.input.username == '' && this.input.password == '';
        },
        isVicensCommunity() {
            if (this.$store.getters.community.partner) {
                return (
                    this.$store.getters.community.partner.name == 'Vicens Vives'
                );
            }
            return false;
        },
    },
    created() {
        console.log('created auth service');
        this.authService = new AuthService();
    },
    methods: {
        login() {
            this.loading = true;
            this.$store
                .dispatch('localLogin', {
                    username: this.input.username,
                    password: this.input.password,
                })
                .then((response) => {
                    this.$router.push({
                        name: 'dashboard',
                        query: {
                            filter: 'mine',
                        },
                    });
                })
                .catch((e) => {
                    this.errorLogin = true;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        loginWithGoogle() {
            let loginURL = new URL(
                'https://accounts.google.com/o/oauth2/v2/auth'
            );
            let params = new URLSearchParams(loginURL.search.slice(1));
            params.append('access_type', 'offline');
            params.append('include_granted_scopes', true);
            params.append(
                'redirect_uri',
                process.env.VUE_APP_GOOGLE_REDIRECT_URI
            );
            params.append('client_id', process.env.VUE_APP_GOOGLE_CLIENT_ID);
            params.append('response_type', 'code');
            params.append('scope', 'email profile openid');
            params.append('prompt', 'consent');
            window.location = `${loginURL}?${params.toString()}`;
        },
        loginWithMicrosoft() {
            this.authService.login().then(
                (idToken) => {
                    if (idToken) {
                        this.performLogin(idToken);
                    }
                },
                () => {}
            );
        },
        performLogin(idToken) {
            this.$store.dispatch('login', { idToken }).then(() => {
                if (null !== localStorage.getItem('currentUri')) {
                    console.log(
                        'UserLoginFOrm currentUri exists in localStorage, trying to redirect',
                        this.$store.getters.user.validated
                    );
                    if (this.$store.getters.user.validated) {
                        let currentUri = localStorage.getItem('currentUri');
                        localStorage.removeItem('currentUri');
                        this.$router.push({ path: currentUri });
                    } else {
                        this.$router.push({
                            name: 'profile',
                        });
                    }
                } else {
                    // if (this.$store.getters.user.validated) {
                    this.$router.push({
                        path: '/dashboard',
                        query: {
                            filter: 'mine',
                        },
                    });
                    /*} else {
            this.$router.push({
              name: "profile"
            });
          }*/
                }
            });
        },
        loginWithVVives() {
            window.location = `${process.env.VUE_APP_ROOT_API}/es/vicens`;
        },
        loginAnonymous() {
            if (!this.showAlias) {
                this.showAlias = true;
                return;
            }
            if (this.alias.length) {
                console.log('login');
                this.$store.dispatch('logout').then(() => {
                    this.$store
                        .dispatch('anonymousLogin', this.alias)
                        .then(() => {});
                });
            }
        },
    },
};
</script>

<style scoped>
.button {
    border-radius: 6px;
}
</style>
